import { render, staticRenderFns } from "./DemoBase.vue?vue&type=template&id=27196734&scoped=true&"
import script from "./DemoBase.vue?vue&type=script&lang=js&"
export * from "./DemoBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27196734",
  null
  
)

export default component.exports